var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',_vm._b({attrs:{"color":_vm.statusColor,"label":true,"small":""}},'v-chip',_vm.$props,false),[_vm._v("\n  "+_vm._s(_vm.$t(("list.statuses." + _vm.status)))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }